import { render, staticRenderFns } from "./TodoPage.vue?vue&type=template&id=5828cf9f"
import script from "./TodoPage.vue?vue&type=script&lang=js"
export * from "./TodoPage.vue?vue&type=script&lang=js"
import style0 from "./TodoPage.vue?vue&type=style&index=0&id=5828cf9f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports